export enum CargoStatus {
    LOADED = 0,
    EMPTY = 1,
    NO_SENSOR = 2,
    SENSOR_ERROR = 3,
}
